import { render } from "./client-distributions.vue?vue&type=template&id=04caea80"
import script from "./client-distributions.vue?vue&type=script&lang=js"
export * from "./client-distributions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__